import { defineStore } from "pinia";
import { api } from "@lr-notitia/notitia-engineer/client";
import { Dependency, Graph } from "@lr-notitia/notitia-model-store/schemas";

export const useDependenciesStore = defineStore("dependencies", () => {
	const graphs: { [key: string]: Graph } = {};

	function loadGraphs(dependencies: Dependency[]): Promise<void> {
		return new Promise((resolve) => {
			if (!dependencies) return;
			const promises: Promise<any>[] = [];
			dependencies.forEach((d: Dependency) => {
				promises.push(api().domain(d.domainId).graph().get(d.version));
			});
			if (promises.length === 0) return resolve();

			Promise.all(promises).then((data) => {
				data.forEach((d) => {
					graphs[d.domainId] = d;
				});
				resolve();
			});
		});
	}
	function clearGraphs() {
		Object.keys(graphs).forEach((key) => {
			delete graphs[key];
		});
	}

	function getNodeGraph(nodeId: string): Graph | undefined {
		return Object.values(graphs).find((g) => g.nodes[nodeId]);
	}

	return {
		graphs,
		loadGraphs,
		clearGraphs,
		getNodeGraph,
	};
});
